import {
  BILLING_ALL_RECORDS_REQUEST,
  BILLING_ALL_RECORDS_SUCCESS,
  BILLING_ALL_RECORDS_FAIL,
  BILLING_SUBMIT_REQUEST,
  BILLING_SUBMIT_SUCCESS,
  BILLING_SUBMIT_FAIL,
  BILLING_SUBMIT_RESET,
  BILLING_BULK_UPDATE_REQUEST,
  BILLING_BULK_UPDATE_SUCCESS,
  BILLING_BULK_UPDATE_FAIL,
  BILLING_BULK_UPDATE_RESET,
  BILLING_SUPERVISOR_BANKS_REQUEST,
  BILLING_SUPERVISOR_BANKS_SUCCESS,
  BILLING_SUPERVISOR_BANKS_FAIL,
  BILLING_STATUS_UPDATE_REQUEST,
  BILLING_STATUS_UPDATE_SUCCESS,
  BILLING_STATUS_UPDATE_FAIL,
  BILLING_STATUS_UPDATE_RESET,
  BILLING_MASTER_LIST_REQUEST,
  BILLING_MASTER_LIST_SUCCESS,
  BILLING_MASTER_LIST_FAIL,
  BILLING_MASTER_CREATE_REQUEST,
  BILLING_MASTER_CREATE_SUCCESS,
  BILLING_MASTER_CREATE_FAIL,
  BILLING_MASTER_CREATE_RESET,
  BILLING_MASTER_UPDATE_REQUEST,
  BILLING_MASTER_UPDATE_SUCCESS,
  BILLING_MASTER_UPDATE_FAIL,
  BILLING_MASTER_UPDATE_RESET,
  BILLING_MASTER_DELETE_REQUEST,
  BILLING_MASTER_DELETE_SUCCESS,
  BILLING_MASTER_DELETE_FAIL,
  BILLING_MASTER_DELETE_RESET,
  BILLING_MASTER_BULK_DELETE_REQUEST,
  BILLING_MASTER_BULK_DELETE_SUCCESS,
  BILLING_MASTER_BULK_DELETE_FAIL,
  BILLING_MASTER_BULK_DELETE_RESET,
} from '../constants/billingMasterConstants';

export const billingAllRecordsReducer = (state = { records: [] }, action) => {
  switch (action.type) {
    case BILLING_ALL_RECORDS_REQUEST:
      return { loading: true, records: [] };
    case BILLING_ALL_RECORDS_SUCCESS:
      return { loading: false, records: action.payload };
    case BILLING_ALL_RECORDS_FAIL:
      return { loading: false, error: action.payload, records: [] };
    default:
      return state;
  }
};

export const billingSubmitReducer = (state = {}, action) => {
  switch (action.type) {
    case BILLING_SUBMIT_REQUEST:
      return { loading: true };
    case BILLING_SUBMIT_SUCCESS:
      return { loading: false, success: true, records: action.payload };
    case BILLING_SUBMIT_FAIL:
      return { loading: false, error: action.payload };
    case BILLING_SUBMIT_RESET:
      return {};
    default:
      return state;
  }
};

export const billingBulkUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case BILLING_BULK_UPDATE_REQUEST:
      return { loading: true };
    case BILLING_BULK_UPDATE_SUCCESS:
      return { loading: false, success: true, records: action.payload };
    case BILLING_BULK_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case BILLING_BULK_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const billingSupervisorBanksReducer = (state = { banks: [] }, action) => {
  switch (action.type) {
    case BILLING_SUPERVISOR_BANKS_REQUEST:
      return { loading: true, banks: [] };
    case BILLING_SUPERVISOR_BANKS_SUCCESS:
      return { loading: false, banks: action.payload };
    case BILLING_SUPERVISOR_BANKS_FAIL:
      return { loading: false, error: action.payload, banks: [] };
    default:
      return state;
  }
};

export const billingStatusUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case BILLING_STATUS_UPDATE_REQUEST:
      return { loading: true };
    case BILLING_STATUS_UPDATE_SUCCESS:
      return { loading: false, success: true, record: action.payload };
    case BILLING_STATUS_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case BILLING_STATUS_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const billingMasterListReducer = (
  state = { records: [], currentPage: 1, totalPages: 1, totalRecords: 0 },
  action,
) => {
  switch (action.type) {
    case BILLING_MASTER_LIST_REQUEST:
      return { loading: true, records: [] };
    case BILLING_MASTER_LIST_SUCCESS:
      return {
        loading: false,
        records: action.payload.records,
        currentPage: action.payload.currentPage,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
      };
    case BILLING_MASTER_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const billingMasterCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case BILLING_MASTER_CREATE_REQUEST:
      return { loading: true };
    case BILLING_MASTER_CREATE_SUCCESS:
      return { loading: false, success: true, record: action.payload };
    case BILLING_MASTER_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case BILLING_MASTER_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const billingMasterUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case BILLING_MASTER_UPDATE_REQUEST:
      return { loading: true };
    case BILLING_MASTER_UPDATE_SUCCESS:
      return { loading: false, success: true, record: action.payload };
    case BILLING_MASTER_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case BILLING_MASTER_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const billingMasterDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case BILLING_MASTER_DELETE_REQUEST:
      return { loading: true };
    case BILLING_MASTER_DELETE_SUCCESS:
      return { loading: false, success: true };
    case BILLING_MASTER_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case BILLING_MASTER_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

export const billingMasterBulkDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case BILLING_MASTER_BULK_DELETE_REQUEST:
      return { loading: true };
    case BILLING_MASTER_BULK_DELETE_SUCCESS:
      return { loading: false, success: true };
    case BILLING_MASTER_BULK_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case BILLING_MASTER_BULK_DELETE_RESET:
      return {};
    default:
      return state;
  }
};
